<template>
<div>
    <Menu/>
    <Banner/>
    <Servicios/>
    <Noticias/>
    <Equipo/>
    <Footer/>
    
</div> 

</template>

<script>
import Menu from '../components/Menu.vue'
import Banner from '../components/Banner.vue'
import Equipo from '../components/Equipo.vue'
import Footer from '../components/Footer.vue'
import Servicios from '../components/Servicios.vue'
import Noticias from '../components/Noticias.vue'




export default {
    name: 'page',
    components:{
        Menu,
        Banner,      
        Servicios,
        Noticias,
        Equipo,
        Footer,

        
    }
}
</script>

<style>

</style>
